import React, { useEffect, useState } from 'react'

import { Rating } from "flowbite-react";

export const CustomRating = ({ selectedRate = () => null, rate = null }) => {
    const [rates, setRates] = useState([
        { id: 1, value: 1, filled: false },
        { id: 2, value: 2, filled: false },
        { id: 3, value: 3, filled: false },
        { id: 4, value: 4, filled: false },
        { id: 5, value: 5, filled: false }
    ])

    const handleRate = (item) => {
        const { value } = item;
        const newRates = [...rates]?.map(rate => ({
            ...rate,
            filled: Boolean(rate?.value <= value)
        }))
        setRates(newRates)
        selectedRate(value)
    }

    useEffect(() => {
        const newRates = [...rates]?.map(restp => ({ ...restp, filled: Boolean(restp?.value <= rate) }))
        setRates(newRates)
        //eslint-disable-next-line 
    }, [rate])

    return (
        <Rating size="md">
            {!!rates?.length && rates?.map(rate =>
                <Rating.Star role="button" onClick={() => handleRate(rate)} key={rate?.id} filled={rate.filled} />)}
        </Rating>
    );
}